export default __webpack_public_path__ + "static/media/bubble_nova_background_l2.09ed4cf0.jpg";